module.exports = __webpack_public_path__ + "static/media/discover_gray.7b9691cd.svg";